import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledTrafficChangeGraphContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 16px;
  width: 100%;
`;

export const StyledTrafficChangeLatestDataContainer = styled.div`
  display: inline-flex;
  align-items: flex-end;
  column-gap: 4px;
  margin: 10px 0 6px;
`;

export const StyledTrafficChangeLatestData = styled.span`
  ${setFontVariant('h3', colorsPalettes.carbon[400])};
  font-size: 26px;
  line-height: 26px;
`;

export const StyledTrafficChangeLatestDataDate = styled.span`
  ${setFontVariant('caption', colorsPalettes.carbon[400])};
  line-height: normal;
`;

export const StyledTrafficChangeDiffContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-bottom: 10px;

  ${SWReactIcons} {
    transform: translateY(-3.5px);
  }
`;

export const StyledTrafficChangePeriod = styled.span`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])};
  line-height: 12px;
`;

export const StyledTrafficChangeGraphDates = styled.div`
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  ${setFontVariant('report', colorsPalettes.carbon[250])};
  font-size: 10px;
  line-height: normal;
`;
